import { useState, React } from "react";
import CategoryButtons from './components/CategoryButtons.jsx';
import ProductList from './components/ProductList.jsx';
import allProducts from "./components/index.js";
import styles from "../style.js";
import "../index.css"
import Footer from "../components/Footer"
import transition from "../components/transition.jsx";
import { Reveal } from "../components/reveal.jsx";

const Products = () => {
  const categories = [
    'Fintech', 'Social Commerce', 'Creator Community', 
    'AI', 'Moonshots & Frontier Tech'
  ];

  // Set 'All' as the default selected category
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  // Filter products by selected category
  const filteredProducts = !selectedCategory ? allProducts  : allProducts.filter(product => product.category === selectedCategory);

  return (
    <section className={`flex`}>
      <ProductList products={filteredProducts}/>         
    </section>
  )
}
export default Products;


/**
 * <div className={`sticky top-24 z-10 !important ${styles.flexCenter} flex-col gap-5`}>
        <div className="w-full overflow-x-auto overflow-y-hidden" style={{ msOverflowStyle: 'none', scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch'}}>
          <div className="flex flex-nowrap gap-2 px-4 py-2 h-[40px] items-center justify-center" style={{ minWidth: 'max-content' }}>
            <CategoryButtons
              categories={categories} 
              selectedCategory={selectedCategory}
              onSelectCategory={setSelectedCategory}
            />
          </div>
        </div>
        {window.innerWidth < 768 && (
          <p className={`text-ss text-secondary text-center animate-pulse`}>
            -+-- scroll categories sideways --+-
          </p>
        )}
      </div>
 */